import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCC61ikZhFgSwOvykIYKImqDrA5FpbQoyk",
  authDomain: "mirancho-9403b.firebaseapp.com",
  projectId: "mirancho-9403b",
  storageBucket: "mirancho-9403b.firebasestorage.app",
  messagingSenderId: "235659356163",
  appId: "1:235659356163:web:78a20b94c8b1cd8d284636",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });
